// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt20CircleFilled: FC<Receipt20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-6-6.378V18h12V7.286c0-.354-.126-.657-.378-.908A1.238 1.238 0 0 0 16.714 6H7.286c-.354 0-.657.126-.908.378A1.238 1.238 0 0 0 6 7.286v10.336Zm9.429-2.193h-5.143v-1.286h5.143v1.286Zm0-2.786H8.57v-1.286h6.858v1.286Zm0-2.786H8.57V8.571h6.858v1.286Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Receipt20CircleFilled;
